import * as React from 'react';

const IconSquiggle1 = (props) => (
    <svg
        {...props}
        fill='none'
        height={546}
        viewBox='0 0 391 546'
        width={391}
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M13.25 524.793C703.93 114.306 139.305 246.181 297.697 14.2501'
            stroke='#FC5200'
            strokeLinejoin='bevel'
            strokeWidth={48.614} />
    </svg>
);

export default IconSquiggle1;
